<template>
  <UiListItem
    :value="value"
    class="dropdown-item"
    :class="{ 'dropdown-item--active': activeMode === 'color' && isActive }"
    @click="emit('click', value)"
  >
    <template #prepend>
      <slot name="prepend" />
    </template>

    <UiListItemTitle
      class="dropdown-item__title"
      :class="{
        'dropdown-item__title--active': activeMode === 'color' && isActive,
      }"
    >
      <slot />
    </UiListItemTitle>
    <template v-if="isActive && activeMode === 'default'" #append>
      <UiIcon icon="$check" color="icon-accent" size="20" />
    </template>
  </UiListItem>
</template>

<script setup lang="ts">
import { UiListItem, UiListItemTitle, UiIcon } from '~/ui';

type ActiveMode = 'default' | 'color';
export interface Props {
  value: string;
  isActive?: boolean;
  activeMode?: ActiveMode;
}

withDefaults(defineProps<Props>(), {
  isActive: false,
  activeMode: 'default',
});

const emit = defineEmits<(e: 'click', value: string) => void>();
</script>

<style scoped lang="scss">
.dropdown-item {
  &--active {
    background-color: rgb(var(--v-theme-bg-accent-subtle));
  }

  &__title {
    &--active {
      color: rgb(var(--v-theme-secondary));
    }
  }
}
</style>
